import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en.js';
import { es } from './es.js';
import { ptBR } from './pt-BR.js';

export const LANGUAGES = [
  { code: 'pt-BR', label: 'Português' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
] as const;
export type Language = (typeof LANGUAGES)[number]['code'];

const STORAGE_KEY = 'lastrouter.idioma';

/** Preferência guardada no navegador; se o armazenamento falhar, segue o idioma do navegador. */
export function initialLanguage(): Language {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && LANGUAGES.some((l) => l.code === saved)) return saved as Language;
  } catch {
    // armazenamento bloqueado: usa o do navegador
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language.toLowerCase() : 'pt-br';
  if (nav.startsWith('en')) return 'en';
  if (nav.startsWith('es')) return 'es';
  return 'pt-BR';
}

export function setLanguage(lang: Language): void {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // preferência só desta sessão
  }
}

void i18n.use(initReactI18next).init({
  resources: { 'pt-BR': { translation: ptBR }, en: { translation: en }, es: { translation: es } },
  lng: initialLanguage(),
  fallbackLng: 'pt-BR',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
